import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  Box,
  TableContainer,
  Table,
  Typography,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  IconButton,
  FormControl,
  TextField,
  Button,
} from "@mui/material";
import CustomModal from "../CustomModal/CustomModal";
import AddNewReport from "../ModalChildren/AddNewReport";
import { dateFiled } from "../../style/AppointmentStyle";
import MobileScreenShareRoundedIcon from "@mui/icons-material/MobileScreenShareRounded";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import { drTableRow } from "../../style/DoctorListComponent";
import {
  tableCellLab,
  tableHeadCell,
  tableRowLab,
} from "../../style/LapPageStyle";
import {
  getExternalReportForAPatient,
  getPatientPreviousReport,
} from "../../connections/getApi";
import ComponentToPrint from "./printContent";
import ReactToPrint from "react-to-print";
import updownar from "../../assets/updownar.svg";
import UseFetchExternalLabReports from "../../helper/UseFetchExternalLabReports";
import ViewExternalReports from "../ModalChildren/ViewExternalReports";
import LabExternalPrint from "../PrintCompoents/LabExternalPrint";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { showToast } from "../../utils/toastUtil";
import dayjs from "dayjs";
import { primaryBtnTeal } from "../../style/PatientDetailsStyle";
import AddExternalLabReports from "../ModalChildren/AddExternalLabReports";
import AddIcon from "@mui/icons-material/Add";
import AiImageScanReport from "./AiImageScanReport";

const External = () => {
  const [testDate, setDateTest] = useState(
    dayjs().tz("Asia/Kolkata").format("YYYY-MM-DD"),
  );
  const [openModal, setOpenModal] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(120);
  const [cellData, setCellData] = useState({});
  const printRef = useRef();
  const [selectedPatient, setSelectedPatient] = useState({});
  const [printData, setPrintData] = useState({
    reportData: "",
    patientData: "",
  });
  const [patientReports, setPatientReports] = useState([]);
  const [patientFileReports, setPatientFileReports] = useState([]);
  const [lastPage, setLastPage] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisibleScanImage, setModalVisibleScanImage] = useState(false);

  const handlePreview = async (patient, modalFalse = false) => {
    try {
      const data = await getExternalReportForAPatient(testDate, patient?.id);
      setSelectedPatient(patient);
      // console.log(data?.medical_reports, 'data?.medical_reports?.medical_test_reports')
      setPatientReports(data?.medical_reports);
      setPatientFileReports(data?.medical_report_files);
      setOpenModal(modalFalse ? false : true);
    } catch (error) {
      console.log(error);
    }
  };

  const handlePrint = async (patient) => {
    try {
      const data = await getExternalReportForAPatient(testDate, patient?.id);
      setSelectedPatient(patient);
      setPatientReports(data?.medical_reports);
      setPrintData({
        reportData: data?.medical_reports || [],
        patientData: patient,
      });

      if (data?.medical_reports?.length > 0) {
        setTimeout(() => {
          document.getElementById("print-button").click();
          printRef.current.click();
        }, 500);
      } else {
        showToast(
          "Nothing to print. This patient's reports are in image or PDF format.",
          "ERROR",
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const directPrintReport = () => {
    setOpenModal(true);
  };
  const { data: reports, refetch } = UseFetchExternalLabReports(
    testDate,
    page,
    perPage,
  );

  const totalRecords = reports?.meta?.total_count || 0;
  const totalPage = Math.ceil(totalRecords / perPage);

  const handlePrevious = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const handleNext = () => {
    if (page < totalPage) setPage((prev) => prev + 1);
  };

  const handleLast = (page) => {
    setPage(page);
    setLastPage(!lastPage);
  };

  // useEffect(() => {
  //   if (!modalVisible) {
  //     refetch();
  //   }
  // }, [modalVisible]);

  return (
    <Box
      sx={{
        minHeight: "40vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Grid
        container
        sm={12}
        md={12}
        marginBottom={"auto"}
        lg={12}
        mb={"50px"}
        sx={{
          backgroundColor: "neutral.blueShadeBg",
        }}
      >
        <Grid item xs={11.5} mt={0} sx={{ margin: "auto" }}>
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            flexWrap={"wrap"}
            gap={2}
          >
            {/* <Grid item>
              {totalPage > 1 && (
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    gap: "20px",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography variant="body_Grey" color={"neutral.black"}>
                    Displaying Reports {page} - {totalPage} of{" "}
                    {reports?.meta?.total_count} in total
                  </Typography>

                  <Box
                    // mt={2}
                    gap={1}
                    justifyContent="end"
                    display="flex"
                    alignItems="center"
                  >
                    <Button
                      onClick={handlePrevious}
                      startIcon={
                        <ArrowBackIcon sx={{ fontSize: "14px !important" }} />
                      }
                      sx={{
                        fontSize: "12px",
                        textTransform: "capitalize",
                        border: 1 ? "none" : "1px solid rgba(0, 0, 0, 0.2)",
                        color: page === 1 ? "grey" : "neutral.teal",
                      }}
                    >
                      Previous
                    </Button>

                    <Button
                      sx={{
                        fontSize: "12px",
                        minWidth: "24px",
                        minHeight: "24px",
                        padding: "2px",
                        borderRadius: "4px",
                        border: 2 ? "none" : "1px solid rgba(0, 0, 0, 0.2)",
                        // color: page === currentPage ? "black" : "inherit",
                        // backgroundColor:
                        //   page === currentPage ? "rgba(0, 0, 0, 0.1)" : "inherit",
                      }}
                    >
                      {page}
                    </Button>

                    <Button
                      onClick={handleNext}
                      endIcon={
                        <ArrowForwardIcon
                          sx={{ fontSize: "14px !important" }}
                        />
                      }
                      sx={{
                        fontSize: "12px",
                        textTransform: "capitalize",
                        border: 1 ? "none" : "1px solid rgba(0, 0, 0, 0.2)",
                        color: page === totalPage ? "grey" : "neutral.teal",
                      }}
                    >
                      Next
                    </Button>
                  </Box>
                </Box>
              )}
            </Grid> */}

            <Box
              sx={{
                display: "flex",
                gap: 2,
                alignItems: "center",
                mt: 2,
                flexWrap: "wrap",
              }}
            >
              <Button
                sx={{
                  ...primaryBtnTeal,
                  gap: 1,
                  display: "flex",
                  alignItems: "center",
                  paddingY: 2,
                  textTransform: "none",
                }}
                onClick={() => setModalVisible(true)}
              >
                {/* <AddIcon /> */}
                <Typography sx={{ fontSize: "14px" }}>
                  Add external report
                </Typography>
              </Button>

              {/* <Button
                sx={{
                  ...primaryBtnTeal,
                  gap: 1,
                  display: "flex",
                  alignItems: "center",
                  paddingY: 2,
                  textTransform: "none",
                }}
                onClick={() => setModalVisibleScanImage(true)}
              >
                <Typography sx={{ fontSize: "14px" }}>
                  Import Via Image / PDF
                </Typography>{" "}
              </Button> */}
            </Box>

            <Box>
              <FormControl variant="outlined" sx={{ width: "220px" }}>
                <TextField
                  defaultValue={new Date().toISOString().split("T")[0]}
                  type="date"
                  sx={dateFiled}
                  value={testDate}
                  name="Date"
                  onChange={(e) => setDateTest(e.target.value)}
                />
              </FormControl>
            </Box>
          </Box>

          <TableContainer
            sx={{
              mt: 0,
              overflowY: "scroll",
              "&::-webkit-scrollbar": {
                display: "none", // Hide the scrollbar for Webkit browsers (Chrome, Safari)
              },
              "-ms-overflow-style": "none", // Hide scrollbar for IE and Edge
              "scrollbar-width": "none",
            }}
          >
            <Table
              sx={{
                overflowY: "scroll",
                "&::-webkit-scrollbar": {
                  display: "none", // Hide the scrollbar for Webkit browsers (Chrome, Safari)
                },
                "-ms-overflow-style": "none", // Hide scrollbar for IE and Edge
                "scrollbar-width": "none", // Hide scrollbar for Firefox
              }}
            >
              <TableHead stickyHeader>
                <TableRow>
                  <TableCell
                    sx={{
                      tableHeadCell,
                      color: "neutral.black",
                      textAlign: "center",
                    }}
                  >
                    S.No{" "}
                  </TableCell>
                  <TableCell
                    sx={{
                      tableHeadCell,
                      color: "neutral.black",
                      textAlign: "center",
                    }}
                  >
                    Name{" "}
                  </TableCell>

                  <TableCell
                    sx={{
                      tableHeadCell,
                      color: "neutral.black",
                      textAlign: "center",
                    }}
                  >
                    {" "}
                    Patient ID{" "}
                  </TableCell>

                  <TableCell
                    sx={{
                      tableHeadCell,
                      color: "neutral.black",
                      textAlign: "center",
                    }}
                  >
                    {" "}
                    Actions{" "}
                  </TableCell>

                  {/* <TableCell sx={{tableHeadCell , color:'neutral.black' , textAlign:'center'}}>Print</TableCell> */}
                </TableRow>
              </TableHead>

              <TableBody>
                {reports?.payload?.patients?.length === 0 && (
                  <TableCell
                    sx={{ textAlign: "center" }}
                    colSpan={5}
                    rowSpan={4}
                  >
                    <Typography>No Data</Typography>
                  </TableCell>
                )}
                {reports?.payload?.patients?.map((patient, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      ...tableRowLab,
                      backgroundColor: "white",
                      borderBottom: "8px solid #EEF6F9",
                      borderTop: index === 0 ? "4px solid #EEF6F9" : "",
                      transition: "all 0.3s ease-in-out",
                      "&:hover": {
                        transform: "scale(1.001)",
                        borderRadius: "20px !important",
                      },
                    }}
                  >
                    <TableCell
                      sx={{
                        p: "4px",
                        textAlign: "center",
                        borderTopLeftRadius: "20px",
                        borderBottomLeftRadius: "20px",
                      }}
                    >
                      <Typography variant="body_Grey1" color={"text.grey"}>
                        {index + 1}
                      </Typography>
                    </TableCell>

                    <TableCell
                      sx={{
                        ...tableCellLab,
                        paddingY: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="heading2">
                        {" "}
                        {patient?.full_name}
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <MobileScreenShareRoundedIcon
                          sx={{ height: "12px", width: "12px" }}
                        />
                        <Typography variant="body2_text">
                          {" "}
                          {patient?.mobile}
                        </Typography>
                      </Box>
                    </TableCell>

                    <TableCell sx={tableCellLab}>
                      <Typography variant="body_Grey1">
                        {patient?.uid}
                      </Typography>
                    </TableCell>

                    <TableCell
                      sx={{
                        ...tableCellLab,
                        borderTopRightRadius: "20px",
                        borderBottomRightRadius: "20px",
                      }}
                    >
                      <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <IconButton onClick={() => handlePreview(patient)}>
                          <VisibilityOutlinedIcon
                            sx={{
                              borderRadius: "50%",
                              color: "neutral.teal",
                              width: "20px",
                              cursor: "pointer",
                            }}
                          />
                        </IconButton>

                        <IconButton onClick={() => handlePrint(patient)}>
                          <LocalPrintshopOutlinedIcon
                            sx={{
                              color: "neutral.yellow",
                              width: "20px",
                              cursor: "pointer",
                            }}
                          />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {totalPage > 1 && (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                gap: "20px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography variant="body_Grey" color={"neutral.black"}>
                Displaying Reports {page} - {totalPage} of{" "}
                {reports?.meta?.total_count} in total
              </Typography>

              <Box
                // mt={2}
                gap={1}
                justifyContent="end"
                display="flex"
                alignItems="center"
              >
                <Button
                  onClick={handlePrevious}
                  startIcon={
                    <ArrowBackIcon sx={{ fontSize: "14px !important" }} />
                  }
                  sx={{
                    fontSize: "12px",
                    textTransform: "capitalize",
                    border: 1 ? "none" : "1px solid rgba(0, 0, 0, 0.2)",
                    color: page === 1 ? "grey" : "neutral.teal",
                  }}
                >
                  Previous
                </Button>

                <Button
                  sx={{
                    fontSize: "12px",
                    minWidth: "24px",
                    minHeight: "24px",
                    padding: "2px",
                    borderRadius: "4px",
                    border: 2 ? "none" : "1px solid rgba(0, 0, 0, 0.2)",
                    // color: page === currentPage ? "black" : "inherit",
                    // backgroundColor:
                    //   page === currentPage ? "rgba(0, 0, 0, 0.1)" : "inherit",
                  }}
                >
                  {page}
                </Button>

                <Button
                  onClick={handleNext}
                  endIcon={
                    <ArrowForwardIcon sx={{ fontSize: "14px !important" }} />
                  }
                  sx={{
                    fontSize: "12px",
                    textTransform: "capitalize",
                    border: 1 ? "none" : "1px solid rgba(0, 0, 0, 0.2)",
                    color: page === totalPage ? "grey" : "neutral.teal",
                  }}
                >
                  Next
                </Button>
              </Box>
            </Box>
          )}
        </Grid>
      </Grid>

      <CustomModal open={openModal} onClose={() => setOpenModal(false)}>
        <ViewExternalReports
          patientData={selectedPatient}
          onClose={() => setOpenModal(false)}
          data={testDate ? testDate : new Date().toISOString().split("T")[0]}
          patientReports={patientReports}
          patientFileReports={patientFileReports}
        />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", width: "85%" }}
        open={modalVisible}
        onClose={() => {
          setModalVisible(false);
          refetch(); // ✅ ADD THIS
        }}
      >
        <AddExternalLabReports
          onClose={() => {
            setModalVisible(false);
          }}
          refetchList={refetch}
        />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", width: "85%" }}
        open={modalVisibleScanImage}
        onClose={() => {
          setModalVisibleScanImage(false);
        }}
      >
        <AiImageScanReport
          onClose={() => {
            setModalVisibleScanImage(false);
          }}
        />
      </CustomModal>

      <ReactToPrint
        trigger={() => (
          <IconButton onClick={directPrintReport} id="print-button">
            <LocalPrintshopOutlinedIcon
              sx={{
                p: "6px",
                paddingX: "8px",
                display: "none",
                color: "neutral.yellow",
                // bgcolor: "neutral.olive",
                // borderRadius: "45%",
                height: "15px",
                width: "15px",
              }}
            />
          </IconButton>
        )}
        content={() => printRef.current}
        pageStyle="@page { size: auto; margin: 6mm; }"
        // pageStyle="@page { size: auto; margin: 20mm; }"
        copyStyles={true}
      />

      <LabExternalPrint
        ref={printRef}
        reportData={printData?.reportData}
        patientData={printData?.patientData}
        selectedDate={
          testDate ? testDate : new Date().toISOString().split("T")[0]
        }
      />
    </Box>
  );
};

export default External;
